import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-daterange', 'TIME_START', 'Algaeg');
Labels.set('ui-daterange', 'TIME_END', 'Lōppaeg');
